import { Box, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";

import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import StarIcon from "@mui/icons-material/Star";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { DefaultLoader, Dropdown, SavingItem } from "../../components";
import { icons } from "../../constants";
import { setBlockRequest, setCommingFrom } from "../../globalRedux/actions";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { setStatus } from "../../utils/functions/goalCombineTrx";
import { getCustomerGoals, hideError } from "../redux/action";

const GoalList = props => {
  const {
    loading,
    customerGoals,
    getCustomerGoals,
    history,
    setCommingFrom,
  } = props;

  const [isOpenBottom, setOpenBottom] = useState(false);
  const [savingGoal, setSavingGoal] = useState([]);

  /**
   *  Get saving goal list from API
   */
  useEffect(() => {
    getCustomerGoals();
  }, []);

  /** Save saving goal into local state */
  useEffect(() => {
    if (customerGoals && customerGoals.length > 0) {
      sortGoalsByCreatedDate(setStatus(customerGoals));
    }
  }, [customerGoals]);

  const sortGoalsByCreatedDate = goals => {
    setSavingGoal([
      ...goals.sort((a, b) => moment(b.dateCreated) - moment(a.dateCreated)),
    ]);
  };

  /** Sort by most recent date */
  const handleSortRecent = () => {
    sortGoalsByCreatedDate(savingGoal);
    setOpenBottom(false);
  };

  /** Sort by completed */
  const handleSortCompleted = () => {
    setSavingGoal(prev => [
      ...prev.sort(
        (a, b) => Number(b.targetPercentage) - Number(a.targetPercentage)
      ),
    ]);
    setOpenBottom(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#f6f6f8"
      }}
    >
      {loading && <DefaultLoader />}

      {/* Sort*/}
      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight / 3}
        isOpen={isOpenBottom}
        handleDismiss={() => setOpenBottom(false)}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "16px 0 24px",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              color: "#262d58",
              margin: "0 16px 16px",
            }}
          >
            Sort by
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 20px 14px",
            }}
          >
            <Typography
              color="textPrimary"
              sx={{
                fontSize: "16px",
                lineHeight: 1.5,
                fontWeight: "700",
                letterSpacing: "0.32px",
              }}
              onClick={handleSortRecent}
            >
              Most recent
            </Typography>
            <img src={icons.arrowRight} alt="arrow-right" />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 20px 14px",
            }}
          >
            <Typography
              color="textPrimary"
              sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: 1.5,
                letterSpacing: "0.32px",
              }}
              onClick={handleSortCompleted}
            >
              Completed
            </Typography>
            <img src={icons.arrowRight} alt="arrow-right" />
          </Box>
        </Box>
      </Dropdown>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "16px 16px 8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <ArrowBackOutlinedIcon
            sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
            onClick={() => history.push("/dashboard")}
          />
          <Typography
            color="secondary"
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4,
              marginLeft: "16px",
            }}
          >
            Financial goals
          </Typography>
        </Box>
        <div
          onClick={() => {
            dataLayerGTM("click_tag", "Click", "Button", "Goal Filter");
            setOpenBottom(true);
          }}
        >
          <img src={icons.sliders} alt="sliders" />
        </div>
      </Box>

      {/* Saving Item */}
      {savingGoal.length > 0 &&
        savingGoal.map(
          (
            {
              planAlias,
              targetAmount,
              totalCashIn,
              portfolio,
              id,
              cashInStatus,
              targetPercentage,
              product: { image },
              plan: { retailFlag },
              currentValue,
            },
            index
          ) => (
            <SavingItem
              key={index}
              cashInSts={cashInStatus}
              retailFlag={retailFlag}
              savingName={planAlias}
              totalSaving={totalCashIn}
              savingTarget={targetAmount}
              savingMonthBar={
                targetPercentage
                  ? Number(targetPercentage)
                  : ((portfolio.unitHeld * portfolio.fund.nav) / targetAmount) *
                    100
              }
              image={image}
              portfolio={portfolio}
              currentValue={currentValue}
              onClick={() => {
                dataLayerGTM("click_tag", "Click", "Link", `${planAlias}`);
                props.setBlockRequest(false);
                setCommingFrom("/goal-list");
                history.push(`/goal-list/${id}`);
              }}
            />
          )
        )}
    </Box>
  );
};

const withConnect = connect(
  state => ({
    ...state.goal,
  }),
  { getCustomerGoals, hideError, setCommingFrom, setBlockRequest }
);

export default compose(
  withRouter,
  withConnect
)(GoalList);
